export const getNavigateContentStyles = (_, { palette = {} }) => ({
  navigateContent: {
    color: palette.neutralPrimary,
  },
  navigateContentLastItem: {
    fontWeight: 'bold',
  },
});
